// Role-based access control matrix
export const NAV_ACCESS = {
  'letterhead.templates':    ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'letterhead.editor':       ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'letterhead.approvals':    ['admin','manager','hod'],
  'letterhead.history':      ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'expense.advance':         ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'expense.claim':           ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'expense.approvals':       ['admin','manager','hod','finance'],
  'expense.finance':         ['admin','finance'],
  'expense.reports':         ['admin','finance','hod','manager'],
  'vendor.master':           ['admin','procurement','finance','manager','hod'],
  'vendor.projects':         ['admin','procurement','finance'],
  'vendor.payment_requests': ['admin','procurement','employee','manager','hod','finance'],
  'vendor.invoice_upload':   ['admin','procurement'],
  'vendor.grn':              ['admin','procurement'],
  'vendor.approvals':        ['admin','manager','hod'],
  'vendor.vendor_approvals': ['admin','manager','hod'],
  'vendor.finance':          ['admin','finance'],
  'vendor.released':         ['admin','finance','procurement'],
  'vendor.reports':          ['admin','finance','hod','manager'],
  'businesscard.request':    ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'businesscard.approvals':  ['admin','manager','hr'],
  'complaints.box':          ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'admin.users':             ['admin'],

  // ── eTAMS additions (Travel & Expenses) ──
  'etams.overview':          ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'etams.travel':            ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'etams.receipts':          ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'etams.policy':            ['admin','employee','manager','hod','finance','procurement','hr','payroll'],

  // ── TSE Workspace ──
  'workspace.wall':          ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'workspace.profile':       ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'workspace.approvals':     ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'workspace.requests':      ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'workspace.policies':      ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'workspace.servicehub':    ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'projectadmin.letters':    ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'projectadmin.codes':      ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'projectadmin.costcenters':['admin','finance','hod','manager','procurement'],
  'it.asset':                ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'it.desk':                 ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'engineering.docs':        ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'procurement.stores':      ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'operations.site':         ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'hradmin.services':        ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'ehs.compliance':          ['admin','employee','manager','hod','finance','procurement','hr','payroll'],
  'finance.control':         ['admin','finance'],
  'finance.cashbook':        ['admin','finance'],
  'admin.console':           ['admin'],
  'admin.workflows':         ['admin'],
};

// Grouped module keys — used by the admin "Create User" screen to let admin pick
// exactly which modules a given user may access (in addition to their role).
export const MODULE_GROUPS = {
  'Letterhead': [
    { key: 'letterhead.templates', label: 'Templates' },
    { key: 'letterhead.editor', label: 'Create / Edit' },
    { key: 'letterhead.approvals', label: 'Approval Flow' },
    { key: 'letterhead.history', label: 'History' },
  ],
  'Travel Expense': [
    { key: 'expense.advance', label: 'Advance Request' },
    { key: 'expense.claim', label: 'Claim Submission' },
    { key: 'expense.approvals', label: 'Approvals' },
    { key: 'expense.finance', label: 'Finance & Settlement' },
    { key: 'expense.reports', label: 'Reports' },
  ],
  'Vendor Payment': [
    { key: 'vendor.master', label: 'Vendor Master' },
    { key: 'vendor.projects', label: 'Project Codes' },
    { key: 'vendor.payment_requests', label: 'Payment Requests' },
    { key: 'vendor.invoice_upload', label: 'Invoice Upload' },
    { key: 'vendor.grn', label: 'GRN Verification' },
    { key: 'vendor.approvals', label: 'L3 Payment Approvals' },
    { key: 'vendor.vendor_approvals', label: 'Vendor Registration Approvals' },
    { key: 'vendor.finance', label: 'Finance Processing' },
    { key: 'vendor.released', label: 'Payment Released' },
    { key: 'vendor.reports', label: 'Reports' },
  ],
  'Business Card': [
    { key: 'businesscard.request', label: 'Business Card Request' },
    { key: 'businesscard.approvals', label: 'Approvals' },
  ],
  'eTAMS': [
    { key: 'etams.overview', label: 'Overview' },
    { key: 'etams.travel', label: 'Travel Requests' },
    { key: 'etams.receipts', label: 'Receipt Centre' },
    { key: 'etams.policy', label: 'Travel Policy' },
  ],
  'Project Admin': [
    { key: 'projectadmin.letters', label: 'Project Letter Generator' },
    { key: 'projectadmin.codes', label: 'Project Code Generation' },
    { key: 'projectadmin.costcenters', label: 'Cost Centers & Categories' },
  ],
  'IT & Facilities': [
    { key: 'it.asset', label: 'IT Asset Request' },
    { key: 'it.desk', label: 'Desk & Office Space' },
  ],
  'Departments': [
    { key: 'engineering.docs', label: 'Engineering & Document Control' },
    { key: 'procurement.stores', label: 'Procurement, Stores & Logistics' },
    { key: 'operations.site', label: 'Project & O&M Site Support' },
    { key: 'hradmin.services', label: 'HR & Administration Services' },
    { key: 'ehs.compliance', label: 'EHS, Quality & Compliance' },
  ],
  'Finance': [
    { key: 'finance.control', label: 'Finance & Payment Control' },
    { key: 'finance.cashbook', label: 'Cashbook & Payment Link' },
  ],
  // Complaint Box is intentionally NOT in here — it's open to every internal
  // user by design (see canAccess below) and is never something an admin
  // picks per-user from the module list.
};

// Modules that are always available to every authenticated internal user,
// regardless of role restrictions or an admin's per-user allowedModules list.
// Complaint Box must stay open to literally anyone so nobody is ever locked
// out of raising a complaint.
const ALWAYS_OPEN_MODULES = [
  'complaints.box',
  // Personal workspace areas every employee always needs
  'workspace.wall', 'workspace.profile', 'workspace.approvals', 'workspace.requests',
  'workspace.policies', 'workspace.servicehub',
];

// canAccess accepts either a full user object ({ role, allowedModules }) or
// (for backward compatibility) a plain role string.
export function canAccess(userOrRole, key) {
  const user = typeof userOrRole === 'string' ? { role: userOrRole } : userOrRole;
  if (!user || !user.role) return false;
  const role = user.role;
  if (role === 'admin') return true;

  const roleAllowed = (NAV_ACCESS[key] || []).includes(role);
  if (!roleAllowed) return false;

  // Always-open modules (e.g. Complaint Box) skip the per-user module
  // restriction entirely — any authenticated internal user can reach them,
  // no matter what the admin scoped their other module access down to.
  if (ALWAYS_OPEN_MODULES.includes(key)) return true;

  // Module gating: if the admin explicitly assigned this user a specific set of
  // modules, restrict to only those — regardless of what their role would normally see.
  if (Array.isArray(user.allowedModules) && user.allowedModules.length > 0) {
    return user.allowedModules.includes(key);
  }
  return true;
}

export const ROLE_CONFIG = {
  admin:       { color: '#7c3aed', bg: '#f3e8ff', label: 'Administrator' },
  employee:    { color: '#16a34a', bg: '#f0fdf4', label: 'Employee' },
  manager:     { color: '#1d4ed8', bg: '#eff6ff', label: 'Manager' },
  hod:         { color: '#0f766e', bg: '#f0fdfa', label: 'Head of Department' },
  finance:     { color: '#b45309', bg: '#fffbeb', label: 'Finance' },
  procurement: { color: '#dc2626', bg: '#fef2f2', label: 'Procurement' },
  hr:          { color: '#be185d', bg: '#fdf2f8', label: 'HR' },
};
